import { InventoryMode, Item, ItemType } from '../types';

/**
 * Reads the new inventory contract while remaining compatible with older API
 * responses and test fixtures that only contain enableBatchTracking.
 */
export function getInventoryMode(item: Pick<Item, 'inventoryMode' | 'itemType' | 'enableBatchTracking'>): InventoryMode {
  if (item.inventoryMode) return item.inventoryMode;
  if (item.itemType === ItemType.SERVICE) return InventoryMode.NONE;
  return item.enableBatchTracking ? InventoryMode.BATCHED : InventoryMode.SIMPLE;
}

export function tracksInventory(item: Pick<Item, 'inventoryMode' | 'itemType' | 'enableBatchTracking'>): boolean {
  return getInventoryMode(item) !== InventoryMode.NONE;
}

export function tracksBatches(item: Pick<Item, 'inventoryMode' | 'itemType' | 'enableBatchTracking'>): boolean {
  return getInventoryMode(item) === InventoryMode.BATCHED;
}
